export default "__VITE_ASSET__CBsRLybn__"